import { JOIN_REJECT_CODE } from '@susdle/shared';
import type { ErrorKind } from './LobbySession.js';

/**
 * Classifies a Colyseus join / joinOrCreate rejection into an ErrorKind by
 * reading the numeric `ServerError.code` the server attached in
 * `SusdleRoom.onAuth` (Epic 14-hardening Items 10/11). Unknown codes fall back
 * to the generic 'join_error'. Pure + unit-tested; wired into LobbySession via
 * `classifyJoinError` in App.buildSessionPromise and devRealSession.
 */
export function classifyJoinError(err: unknown): ErrorKind {
  const code = (err as { code?: unknown } | null | undefined)?.code;
  if (code === JOIN_REJECT_CODE.ROOM_FULL) return 'room_full';
  if (code === JOIN_REJECT_CODE.GAME_IN_PROGRESS) return 'game_in_progress';
  if (code === JOIN_REJECT_CODE.SCHEMA_MISMATCH) return 'schema_mismatch';
  return 'join_error';
}
